import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class CurrentFiltersService {
  private currentFiltersSource = new BehaviorSubject<any>(null);
  public currentFilters$ = this.currentFiltersSource.asObservable();

  private currentSessionSource = new BehaviorSubject<any>(null);
  public currentSessionFilters$ = this.currentSessionSource.asObservable();
  constructor() { }

  asignFilters(filters) {
    this.currentFiltersSource.next(filters);
  }

  clearCurrentFilters() {
    this.currentFiltersSource.next(null);
  }

  sessionActivate() {
    this.currentSessionSource.next(true);
  }
}
